import { Component, OnInit, ComponentFactoryResolver, ViewContainerRef, ViewChild, ComponentRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { MyAccountService } from '../../services/myAccount.service';
import { UsersViewModel, ActiveUserViewModel } from '../../models/account-ledger.model';
import { NgProgress } from 'ngx-progressbar';
import { AuthService } from "../../services/auth.service";
import { NgProgressService } from '../../services/ngProgress.service';
import { Sort } from '@angular/material/sort';

declare var jquery: any;
declare var $: any;

@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.css']
})
export class UsersComponent implements OnInit {

  title = 'Manage Existing Users';
  setFullWindow = false;
  loadContent = false;
  usersList: ActiveUserViewModel[];
  usersListFilter: ActiveUserViewModel[];
  sortedData: ActiveUserViewModel[] = [];
  displayedColumns: string[] = ['loginname', 'accesslevel', 'button'];
  filterText: string;
  hasAdminAccess: boolean = false;
  @ViewChild('entry', { read: ViewContainerRef }) entry: ViewContainerRef;
  public accessLevelList: any = [
    { name: 'All', value: 'all' },
    { name: 'Admin Access', value: 'Y' },      
    { name: 'Purchase Access', value: 'Y' },
    { name: 'View Access', value: 'View' },
    { name: 'MFA Enabled', value: 'E' },
  ];
  public accessLevelModel = 'all'
  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private myAccountService: MyAccountService,
    private authService: AuthService,
    private ngProgress: NgProgressService
  ) { }

  ngOnInit() {
    this.ngProgress.start();
    $('.page-contents').animate({ scrollLeft: $('#levelOne').width() }, 400);
    this.ngProgress.done();
    this.authService.currentLoginInfoWatch.subscribe(loginInfo => {
      this.authService.currentUserModel = loginInfo;
      if (this.authService.currentUserModel != null && this.authService.currentUserModel.hasAdminAccess) {
        this.hasAdminAccess = true;
      }
    });

    this.getUsers();

    this.activatedRoute.queryParamMap.subscribe(param => {
      const needRefresh = param.get('refresh');

      if(needRefresh) {
        this.getUsers();
        this.filterText = '';
      }
    });
    

    if(this.router.url != '/myAccount/users') {
      this.loadContent = true; //set to true to avoid loading screen duplicated issue
    }
  }

  getUsers() {
    this.myAccountService.GetUsers().subscribe((res: UsersViewModel) => {
      if (res && res.activeUsers.length) {
        this.usersList = res.activeUsers;
        this.usersListFilter = this.usersList;
        this.sortedData = this.usersList.slice();
      }
    },
      (error: any) => {
        console.error(error);
        this.ngProgress.done();
      });
  }
  public filterAccessLevel(e) {

    if(e.name == 'Admin Access'){
      this.sortedData = this.usersList.filter(user => user.adminAccess.includes(e?.value));
    }
    else if(e.name == 'Purchase Access'){
      this.sortedData = this.usersList.filter(user => user.purchaseAccess.includes(e?.value));
    }
    else if(e.name == 'View Access'){
    this.sortedData = this.usersList.filter(user => user.roles.includes(e?.value));
    }
    else if(e.name == 'MFA Enabled'){
      this.sortedData = this.usersList.filter(user => user.mfaEnabled.includes(e?.value) || user.mfaEnabled.includes('M'));
    }
    else
      this.sortedData = this.usersList;  
  }   
  
  filterUsersList(): void {
    this.sortedData = this.usersList.filter(user => user.loginName.toLowerCase().includes(this.filterText.toLowerCase()));
  }

  manageUser(user: ActiveUserViewModel): void {
    this.myAccountService.changeUserInfo(user);
    this.router.navigate(['users/manage-user'], { relativeTo: this.activatedRoute.parent });
  }

  addNewUser(): void {
    this.router.navigate(['users/addusers'], { relativeTo: this.activatedRoute.parent });
  }
  // addNewUser(): void {
  //   this.router.navigateByUrl('/myAccount/users/addusers');
  // }

  onLoading(currentLoadingStatus: boolean) {

    this.loadContent = !currentLoadingStatus;
  }

  close() {
    //console.log('close event');
    $('.page-contents').animate({ scrollLeft: -$('#levelOne').width() }, 400);
    this.router.navigateByUrl('/myAccount');
  }

  sortData(sort: Sort) {
    const data = this.usersList;
    if (!sort.active || sort.direction === "") {
      this.sortedData = data;
      return;
    }    
    this.sortedData = data.sort((a, b) => {
      const isAsc = sort.direction === "asc";
      switch (sort.active) {
        case "loginName":
          return compare(
            a.loginName.toLowerCase(),
            b.loginName.toLowerCase(),
            isAsc
          );
          case "mfaEnabled":
            return this.isMFAEnabledCompare(
              a.mfaEnabled,                     
              isAsc
            );
            case "accessLevel":
              return compare(
                a.roles.toLowerCase(),
                b.roles.toLowerCase(),
                isAsc
              );
       
        default:
          return 0;
      }
    });
  }
  public isMFAEnabledCompare( a: number | string ,isAsc: boolean)  { 
    const mfa1 = this.sortedData.filter(user => user.mfaEnabled.includes(a.toString()));
    const mfa2 = this.sortedData.filter(user => user.mfaEnabled.includes('E') || user.mfaEnabled.includes('M'));
    return (mfa1 > mfa2 ? -1 : 1) * (isAsc ? -1 : 1);
  }
}
function compare(a: number | string, b: number | string, isAsc: boolean) {
  return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
}
